define([
	"dojo/_base/declare",
	"csi/table/Widget"
], function(declare,Widget) {

	return declare(Widget, {
		queryLimit: 0
	});
});